import script from "./refund.vue?vue&type=script&setup=true&lang=ts"
export * from "./refund.vue?vue&type=script&setup=true&lang=ts"

import "./refund.vue?vue&type=style&index=0&id=0ffb3474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffb3474"]])

export default __exports__